/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum ManifestType {
    OPEN_CRUISE_ARCHIVE = 'open_cruise_archive',
    SEALED_CRUISE_ARCHIVE = 'sealed_cruise_archive',
    CRUISE_ADDENDUM = 'cruise_addendum',
}
